export default __webpack_public_path__ + "static/media/alert-1-86270.2c18d32f.mp3";